import React from 'react';
import withStyles from '@mui/styles/withStyles';

function OrderedCheckboxIcon({ classes, order }) {
    return (
        <div className={classes.root}>
            <div className={classes.box}>
                <div className={classes.number}>
                    {order}
                </div>
            </div>
        </div>
    );
}

export default withStyles(theme => ({
    root: {
        height: 24,
        width: 24,

        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    box: {
        boxSizing: 'border-box',
        width: 18,
        height: 18,
        maxWidth: 18,
        maxHeight: 18,

        borderRadius: 2,
        backgroundColor: theme.palette.primary.main,

        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden'
    },
    number: {
        fontSize: 12,
        lineHeight: 1,
        color: theme.palette.primary.contrastText
    }
}))(OrderedCheckboxIcon);